import ButtonLoader from 'app/ui_v2/components/button-loader/ButtonLoader';
import TrashIcon from 'app/ui_v2/icons/TrashIcon';

import { Box, IconButton } from '@mui/material';

import { FileInfo } from './MultiFileUploader2';

export interface SignatureViewProps {
  data: FileInfo;
  onFileRemove: (id: string) => void;
  canRemoveFiles?: boolean;
  isLoading: boolean;
}

export default function SignatureView(props: SignatureViewProps) {
  const { data, onFileRemove, canRemoveFiles = false, isLoading } = props;

  return (
    <Box
      sx={{
        minHeight: '300px',
        position: 'relative',
        border: '1px solid #ccc',
        borderRadius: '4px',
        overflow: 'hidden',
      }}
    >
      {/* {data.url} */}
      <img style={{ width: '100%' }} src={data.previewUrl || data.url} alt="Signature" />
      {canRemoveFiles && data.id && (
        <IconButton
          className="outlined-warning fixed-size"
          aria-label="Delete"
          onClick={() => {
            onFileRemove(data?.id || '');
          }}
          sx={{
            position: 'absolute',
            top: '8px',
            right: '8px',
          }}
          disabled={isLoading}
        >
          {isLoading ? <ButtonLoader isActive={true} /> : <TrashIcon />}
        </IconButton>
      )}
    </Box>
  );
}
